import React, { useState } from 'react';
import Card from '../components/Card';
import Filters from '../components/Filters';
import TagsHoc from '../components/hoc/TagsHoc';
import { useData } from '../context/DataContext';

function MessagesPage() {
  const { data, todayLineup } = useData();
  // const [seenMessages, setSeenMessages] = useState<string[]>([]);

  // Load seen messages from localStorage on component mount
  // useEffect(() => {
  //   const storedSeenMessages = localStorage.getItem('seenMessages');
  //   const parsedSeenMessages: string[] = storedSeenMessages ? JSON.parse(storedSeenMessages) : [];
  //   setSeenMessages(parsedSeenMessages);
  // }, []);

  // When messages are loaded, store their IDs in localStorage as "seen"
  // useEffect(() => {
  //   const newSeenMessages = [...seenMessages, ...messages.map(message => message.id)];
  //   const uniqueSeenMessages = Array.from(new Set(newSeenMessages));
  //   localStorage.setItem('seenMessages', JSON.stringify(uniqueSeenMessages));
  // }, [messages, seenMessages]);

  const [activeFilters, setActiveFilters] = useState<string[]>([]);

  const filteredMessages = todayLineup.messages.filter(msg => {
    if (activeFilters.length === 0) return true;

    let filterCheck = true;

    activeFilters.forEach(filter => {
      switch (filter) {
        default: {
          if (data.collections.zones[filter]) {
            filterCheck = filterCheck && (msg.zoneIds.length === 0 || msg.zoneIds.includes(filter));
          }
          break;
        }
      }
    });

    return filterCheck;
  });

  const zoneKeys = Object.keys(data.collections.zones).map(e => data.collections.zones[e]._id);

  return (
    <div id="MessagesPage">
      <Filters
        title={data.appConfig.MESSAGES_LABEL}
        icon={['far', 'message-dots']}
        keys={zoneKeys}
        onFilterChange={setActiveFilters}
        labelExtractor={(key: string) => data.collections.zones[key]?.name}
        rightSide={
          <div className="flex items-center -mr-4">
            <div className="px-4 font-semibold date-picker">{data.appConfig.TODAY_LABEL}</div>
          </div>
        }
      />
      <div className="grid gap-2 pb-8">
        {filteredMessages.map(message => (
          <TagsHoc type="basic" item={message} key={message.id}>
            {props => (
              <Card
                className="border-b"
                title={message.title}
                subtitle={message.description}
                callToActions={message.callToActions}
                tags={props.tags}
              />
            )}
          </TagsHoc>
        ))}
        {filteredMessages.length <= 0 && (
          <div className="italic text-slate px-4 pt-4 text-center">
            {data.appConfig.NO_RESULTS_TEXT}
          </div>
        )}
      </div>
    </div>
  );
}

export default MessagesPage;
